module.exports = __webpack_public_path__ + "static/media/primevideo.d1286f84.png";